export default function disablePowconLinks() {
	// .p-product-card--powcon の中にある aタグだけをピンポイントで取得
	const powconLinks = document.querySelectorAll(".p-product-card--powcon a");

	powconLinks.forEach((link) => {
		const div = document.createElement("div");

		// aタグの中身（ACFフィールドや画像など）をそのままdivに移植
		div.innerHTML = link.innerHTML;

		// CSSが崩れないよう、aタグのクラス名も100%継承
		if (link.className) {
			div.className = link.className;
		}

		// 物理的に <a> から <div> へと置き換える
		link.parentNode.replaceChild(div, link);
	});
}
